import createRoute       from '@widesk-ui/tools/createRoute';
import SubscriptionModel from '@models/account/SubscriptionModel';

export default createRoute.dashboard('/subscriptions', 'account', 'SubscriptionDashboard', SubscriptionModel.localize());